<div
    class="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0 pb-2 sm:pb-2">
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('Land Area')"
        *ngIf="reportType !== 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add Land</span>
    </button>

    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('Builtup Area')"
        *ngIf="reportType !== 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add BuiltUp</span>
    </button>
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new('Carpet Area')"
        *ngIf="reportType === 'FlatOrOfficeOrShop'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add</span>
    </button>
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="deleteSelectedRows()"
        *ngIf="selection.selected.length > 0">
        <mat-icon [svgIcon]="'delete_forever'"></mat-icon>
        <span class="ml-2 mr-1">All Delete</span>
    </button>
</div>
<div class="relative overflow-x-auto overflow-y-auto ">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 table-fixed">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="w-5 p-1 text-center ">
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelectedCheckBox"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [color]="'primary'"
                        [aria-label]="checkboxLabel()">
                    </mat-checkbox>

                </th>
                <th scope="col" class="px-0 py-1 text-center">Order</th>
                <th scope="col" class="p-0 ">Type</th>
                <th scope="col" class="p-0 w-50">Particular</th>
                <th scope="col" class="p-0 text-center">Width (In.Ft)</th>
                <th scope="col" class="p-0 text-center">Depth (In.Ft)</th>
                <th scope="col" class="px-0 py-2 text-center">Total (In.Sq.Ft)</th>
                <th scope="col" class="px-0 py-2 text-center">
                    <span class="sr-only">Actions</span>
                </th>
            </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngIf="siteMeasurements$ | async as siteMeasurements">
                <ng-container *ngIf="siteMeasurements.length; else noSiteMeasurement">
                    <tr class="border-b dark:border-gray-700"
                        *ngFor="let siteMeasurement of siteMeasurements; let i = index; trackBy: trackByFn" cdkDrag>
                        <td class="w-5 p-1 text-center">
                            <mat-checkbox [(checked)]="siteMeasurement.selected" [color]="'primary'"
                                (change)="updateCheckedList($event,siteMeasurement)"></mat-checkbox>
                        </td>
                        <td class="px-0 py-1 p-1 text-center">{{ siteMeasurement.orderIndex }}</td>
                        <td class="p-0 ">{{siteMeasurement.type}}</td>


                        <td class="px-2 w-50">
                            <mat-form-field class="p-0 m-0 w-full">
                                <input type="text" matInput [(ngModel)]="siteMeasurement.particular" (ngModelChange)="particularValueChange($event)"
                                    [matAutocomplete]="autoParticular" [readonly]="!siteMeasurement.isEditing" required>
                                <mat-autocomplete #autoParticular="matAutocomplete"
                                    [displayWith]="displayOptionsFn(options)">
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
                                        {{option.name}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </td>


                        <td class="px-2 text-center">
                            <mat-form-field class="p-0 m-0 w-full">
                                <input matInput class="w-full px-2 py-1 border rounded text-right" type="number"
                                [(ngModel)]="siteMeasurement.width" [readonly]="!siteMeasurement.isEditing"
                                    (ngModelChange)="calculateTotal(siteMeasurement)" />
                            </mat-form-field>
                        </td>

                        <td class="px-2  text-center">
                            <mat-form-field class="w-full">
                                <input matInput class="px-2 py-1 border rounded text-right" type="number"
                                [(ngModel)]="siteMeasurement.depth" [readonly]="!siteMeasurement.isEditing"
                                (ngModelChange)="calculateTotal(siteMeasurement)" />
                            </mat-form-field>
                        </td>

                        <td class="px-2 py-2  text-center">
                            <mat-form-field class="w-full">
                                <input matInput class="w-full px-2 py-1 border rounded text-right"
                                [(ngModel)]="siteMeasurement.total"  [readonly]="siteMeasurement.width != 0 || siteMeasurement.depth != 0"  />
                            </mat-form-field>
                        </td>

                        <td class="px-2 py-2 flex items-center justify-end">

                            <button class="ml-2" mat-icon-button (click)="save(siteMeasurement)"
                                *ngIf="siteMeasurement.isEditing">
                                <mat-icon svgIcon="save"></mat-icon>
                            </button>
                            <button class="ml-2" mat-icon-button *ngIf="!siteMeasurement.isEditing">
                                <mat-icon svgIcon="edit" (click)="toggleEdit(i)"></mat-icon>
                            </button>
                            <button class="ml-2" mat-icon-button *ngIf="siteMeasurement.isEditing">
                                <mat-icon svgIcon="close" (click)="cancelNewRow(i)"></mat-icon>
                            </button>
                            <button class="ml-2" mat-icon-button
                                *ngIf="siteMeasurement.id!==0 && !siteMeasurement.isEditing">
                                <mat-icon svgIcon="delete_forever" (click)="delete(siteMeasurement.id)"></mat-icon>
                            </button>
                        </td>


                    </tr>
                </ng-container>
            </ng-container>

            <ng-template #noSiteMeasurement>
                <tr>
                    <td colspan="4" class="text-sm dark:text-gray-400 font-semibold tracking-tight text-center">There
                        are no
                        Site Measurement!</td>
                </tr>
            </ng-template>
        </tbody>
        <tfoot>
            <tr class="font-semibold text-gray-900 dark:text-white">
                <th class="px-6 py-3"></th>
                <th scope="row" class="px-6 py-3 text-base">Total(In Sq.Ft)</th>
                <td class="px-6 py-3"></td>
                <td class="px-6 py-3">
                    <!-- <span class="font-medium text-gray-500">Area (In.Sq.Ft)</span> <br />
                    {{totalArea | number : '1.2-2'}} -->
                    <mat-form-field class="w-full pr-2 text-right" appearance="outline">
                        <mat-label>Area (In.Sq.Ft)</mat-label>
                        <input matInput [value]="report.siteArea |  number:'1.2-2':'en-IN'" readonly>
                    </mat-form-field>
                </td>
                <td class="px-6 py-3">
                    <!-- <span class="font-medium text-gray-500">BuiltUp (In Sq.Ft)</span><br />
                    {{totalBuiltUp | number:'1.2-2'}} -->
                    <mat-form-field class="w-full pr-2 text-right" appearance="outline">
                        <mat-label>BuiltUp (In Sq.Ft)</mat-label>
                        <input matInput [value]="report.siteBuiltUp  |  number:'1.2-2':'en-IN'" readonly>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline" class="w-full">
                        <mat-label>BuiltUp (In Sq.Ft)</mat-label>
                        <input
                          matInput
                          [value]="report.siteBuiltUp | number:'1.2-2':'en-IN'"
                          readonly
                          style="text-align: right; padding-right: 8px; font-size: 14px; width: 100%; box-sizing: border-box; overflow: hidden; text-overflow: ellipsis;">
                      </mat-form-field>
                       -->
                      
                </td>

                <td class="px-6 py-3">
                    <!-- <span class="font-medium text-gray-500">SBU (In Sq.Ft)</span><br />
                    {{totalSuperBuiltUp | number:'1.2-2'}} -->
                    <mat-form-field class="w-full pr-2 text-right" appearance="outline">
                        <mat-label>SBU (In Sq.ft)</mat-label>
                        <input matInput [(ngModel)]="report.siteSuperBuiltUp"
                            [readonly]="reportType === 'LandAndBuilding'">
                    </mat-form-field>
                </td>
            </tr>
        </tfoot>
    </table>
</div>
